'use client';

import { MotionConfig } from 'framer-motion';
import { ReactNode } from 'react';

/**
 * framer-motion ignores prefers-reduced-motion unless told otherwise.
 * reducedMotion="user" drops transform animations for those users while
 * keeping opacity fades.
 */
const MotionProvider = ({ children }: { children: ReactNode }) => (
  <MotionConfig reducedMotion={'user'}>{children}</MotionConfig>
);

export default MotionProvider;
